import { render, staticRenderFns } from "./CreateVendor.vue?vue&type=template&id=9ca12f54&"
import script from "./CreateVendor.vue?vue&type=script&lang=js&"
export * from "./CreateVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports